import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, UsersIcon, TrendingUpIcon, AwardIcon } from 'lucide-react';
const partners = [{
  name: 'Paripesa',
  logo: 'https://paripesa.co.tz/assets/images/logo.svg'
}, {
  name: '1XBET',
  logo: 'https://1xbet.com/favicon.ico'
}, {
  name: '1Win',
  logo: 'https://1win.com/favicon.ico'
}];
const stats = [{
  icon: UsersIcon,
  value: '20,000+',
  label: 'Active Members',
  color: 'neon-cyan'
}, {
  icon: TrendingUpIcon,
  value: '90%',
  label: 'Predictive Accuracy',
  color: 'neon-green'
}, {
  icon: AwardIcon,
  value: '#1',
  label: 'Trusted in Africa',
  color: 'neon-purple'
}];
export function TrustSection() {
  return <section className="w-full py-20 px-4 bg-dark-base relative overflow-hidden" data-id="element-224">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-10" data-id="element-225">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-neon-cyan rounded-full blur-[150px]" data-id="element-226"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-neon-green rounded-full blur-[150px]" data-id="element-227"></div>
      </div>

      <div className="container mx-auto max-w-7xl relative z-10" data-id="element-228">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-229">
          <div className="inline-flex items-center gap-2 bg-neon-green/10 px-4 py-2 rounded-full mb-4" data-id="element-230">
            <ShieldCheckIcon className="w-5 h-5 text-neon-green" data-id="element-231" />
            <span className="text-neon-green font-semibold text-sm" data-id="element-232">
              TRUSTED & VERIFIED
            </span>
          </div>

          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-233">
            <span className="text-gradient-green" data-id="element-234">
              Why Bettors Trust GreenHS
            </span>
          </h2>

          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-235">
            Join thousands of winning bettors across Africa & diaspora who rely on our
            proven insights
          </p>
        </motion.div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-236">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative group" data-id="element-237">
                <div className="bg-gradient-to-br from-dark-card to-dark-lighter rounded-2xl p-8 border border-gray-800 hover:border-neon-cyan/50 transition-all duration-300 text-center" data-id="element-238">
                  {/* Icon */}
                  <div className={`w-16 h-16 mx-auto mb-4 bg-${stat.color}/20 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform`} data-id="element-239">
                    <Icon className={`w-8 h-8 text-${stat.color}`} data-id="element-240" />
                  </div>

                  {/* Value */}
                  <div className={`text-4xl md:text-5xl font-black mb-2 text-${stat.color}`} data-id="element-241">
                    {stat.value}
                  </div>

                  {/* Label */}
                  <div className="text-gray-400 font-semibold" data-id="element-242">
                    {stat.label}
                  </div>

                  {/* Glow Effect */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none rounded-2xl" data-id="element-243">
                    <div className={`absolute inset-0 bg-${stat.color}/5 rounded-2xl`} data-id="element-244"></div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Partners Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-card/50 backdrop-blur-sm rounded-3xl border border-neon-cyan/20 p-8 md:p-12" data-id="element-245">
          <div className="text-center mb-8" data-id="element-246">
            <h3 className="text-2xl md:text-3xl font-black mb-2 text-white" data-id="element-247">
              Officially Associated With
            </h3>
            <p className="text-gray-400" data-id="element-248">
              Trusted partnerships with leading betting platforms
            </p>
          </div>

          {/* Partner Logos */}
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12" data-id="element-249">
            {partners.map((partner, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="group" data-id="element-250">
                <div className="bg-white/5 hover:bg-white/10 rounded-2xl p-6 border border-gray-700 hover:border-neon-cyan/50 transition-all duration-300 min-w-[140px] flex items-center justify-center" data-id="element-251">
                  <div className="text-center" data-id="element-252">
                    <div className="text-2xl font-black text-white mb-1 group-hover:text-neon-cyan transition-colors" data-id="element-253">
                      {partner.name}
                    </div>
                    <div className="text-xs text-gray-500 font-semibold" data-id="element-254">
                      PARTNER
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* Trust Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="mt-12 text-center" data-id="element-255">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-neon-green/20 to-neon-cyan/20 border border-neon-green/30 rounded-full px-6 py-3" data-id="element-256">
              <ShieldCheckIcon className="w-16 h-16 text-neon-green" data-id="element-257" />
              <span className="font-semibold text-white" data-id="element-258">
                Fast-Growing African Betting Community
              </span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}